import { NotificationEnum } from "@graphql/generated/graphql.g";

type Props = {
  notificationType: NotificationEnum;
};

const NOTIFICATION_TYPE_LABELS: Record<string, string> = {
  FILE_UPLOAD: "File Upload",
  SAAS_DISCOVERED: "SaaS Discovered",
  SHARED_LOGIN: "Shared Login",
};

export const NotificationTypeMappingText = ({ notificationType }: Props) => {
  return NOTIFICATION_TYPE_LABELS[notificationType as string] || "Unknown Notification Type";
};
